import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight, ChevronDown } from "lucide-react";

export default function FAQ() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';
  const [openIdx, setOpenIdx] = useState(null);

  const faqs = [
    { q: t("pages.faq_general_q"), a: t("pages.faq_general_a") },
    { q: t("pages.faq_streaming_q"), a: t("pages.faq_streaming_a") },
    { q: t("pages.faq_premium_q"), a: t("pages.faq_premium_a") },
    { q: t("pages.faq_payment_q"), a: t("pages.faq_payment_a") },
    { q: t("pages.faq_technical_q"), a: t("pages.faq_technical_a") },
    { q: t("pages.faq_account_q"), a: t("pages.faq_account_a") },
  ];

  return (
    <div className="min-h-screen bg-[#050814]" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <nav className="flex items-center gap-2 text-sm text-[#94A3B8] mb-8">
          <Link to="/" className="hover:text-white transition-colors">{lang === 'fr' ? 'Accueil' : 'Home'}</Link>
          <ChevronRight size={14} />
          <span className="text-[#FFC928]">{t("pages.faqTitle")}</span>
        </nav>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl sm:text-4xl font-bold text-white mb-8"
          style={{ fontFamily: 'Poppins' }}
          data-testid="faq-title"
        >
          {t("pages.faqTitle")}
        </motion.h1>

        <div className="space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIdx === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.06 }}
                className="rounded-2xl border border-white/[0.06] bg-[#0F172A] overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left hover:bg-white/[0.02] transition-colors"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="text-white font-medium text-sm pr-4">{faq.q}</span>
                  <ChevronDown size={18} className={`text-[#FFC928] flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      <div className="px-5 pb-5 border-t border-white/[0.06]">
                        <p className="text-[#94A3B8] text-sm leading-relaxed pt-4">{faq.a}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
